import { Button, Grid, Header, Image, Segment } from "semantic-ui-react";
import PropTypes from "prop-types";

const EmptyState = ({ title, detail, image, action }) => {
  if (!title) return null;

  return (
    <Segment basic>
      <Grid centered stackable>
        <Grid.Row columns={1} centered>
          <Grid.Column textAlign={"center"}>
            {image && <Image size={"small"} src={image} centered />}
            <Header
              size="medium "
              content={title}
              subheader={detail}
              textAlign="center"
            />
            {action}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string,
  detail: PropTypes.string,
  image: PropTypes.string,
  action: PropTypes.node,
};

export default EmptyState;
